import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule()
export class IconsModule
{
    /**
     * Constructor
     */
    constructor(
        private _domSanitizer: DomSanitizer,
        private _matIconRegistry: MatIconRegistry
    )
    {
        // Register icon sets
        this._matIconRegistry.addSvgIconSet(this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('mat_outline', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('mat_solid', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('feather', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'));
        // VERSÃO no nome do sprite = cache-busting OBRIGATÓRIO. Os assets de
        // src/assets NÃO recebem hash do build e são servidos com
        // Cache-Control: max-age=31536000 (1 ano) na borda (nginx/Cloudflare).
        // ALTEROU o sprite heroicons-outline.svg (adicionou/removeu ícone) →
        // BUMP para -vN e atualize este path, senão navegador/CDN continuam
        // servindo o sprite ANTIGO com a mesma URL (bug 2026-08-19:
        // heroicons_outline:qr-code ausente em produção — o deploy subiu o
        // bundle novo mas o sprite continuou stale por cache).
        // v3 (2026-09-19): adicionado `banknotes` (menu Contas a Pagar, ctp-access).
        this._matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline-v3.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'));
    }
}
